import { defineStyleConfig, defineStyle } from '@chakra-ui/react';

const bankSelect = defineStyle({
  field: {
    color: 'rentals.primary.txt',
    padding: '8px 16px 8px 16px',
    border: '1px solid #DFDEE2',
    borderRadius: '6px',
    '&:invalid': {
      color: '#9F9DB0',
    },
  },
  icon: { color: '#9F9DB0' },
});

const Select = defineStyleConfig({
  variants: { bankSelect },
});

export default Select;
